export default "__VITE_ASSET__YtlYK5Wn__"